import { OFFER_TYPE_LAST_MINUTE, OFFER_TYPE_HOTEL, OFFER_TYPE_TOUR, OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_BED_BANK, OFFER_TYPE_TOUR_V2, OFFER_TYPE_CRUISE } from 'constants/offer'
import { CRUISE_PRODUCT_LABEL, FLASH_HOTEL_PRODUCT_LABEL, LME_HOTEL_PRODUCT_LABEL, LPP_PRODUCT_LABEL, TAO_HOTEL_PRODUCT_LABEL, TOUR_PRODUCT_LABEL, TOUR_V2_PRODUCT_LABEL } from 'constants/productLabel'

const baseConfig: App.BaseAppConfig = {
  whyBookWithUs: {
    type: 'compact',
  },
  offerDetails: {
    breadCrumbs: [],
  },
  brandConfig: {
    brandHoliday: 'escape',
    holidaySynonym: 'escape',
    adventureSynonym: 'adventure',
    travelSynonym: 'package',
    purchaseSynonym: 'purchase',
    bookingSynonym: 'booking',
    purchasesTerm: 'purchases',
    subscriptionParentBrand: '',
    privacyPolicySynonym: 'Privacy Policy',
  },
  productTypeLabelMap: {
    [OFFER_TYPE_HOTEL]: FLASH_HOTEL_PRODUCT_LABEL,
    [OFFER_TYPE_LAST_MINUTE]: LME_HOTEL_PRODUCT_LABEL,
    [OFFER_TYPE_ALWAYS_ON]: TAO_HOTEL_PRODUCT_LABEL,
    [OFFER_TYPE_BED_BANK]: LPP_PRODUCT_LABEL,
    [OFFER_TYPE_TOUR]: TOUR_PRODUCT_LABEL,
    [OFFER_TYPE_TOUR_V2]: TOUR_V2_PRODUCT_LABEL,
    [OFFER_TYPE_CRUISE]: CRUISE_PRODUCT_LABEL,
  },
  offerList: {
    lightFilter: false,
    howItWorks: {
      showToLoggedIn: false,
      [OFFER_TYPE_TOUR]: [{
        icon: 'handpicked-partner',
        title: 'Best Price Guarantee',
        content: 'Found a better price? We’ll match it… plus more.',
        iconSize: 48,
        slug: 'best-price-guarantee',
        contentSize: 'large',
      }, {
        icon: 'hotel',
        title: 'Handpicked Partners',
        content: 'We work with the world’s most loved brands in travel',
        iconSize: 48,
        contentSize: 'large',
      }, {
        icon: 'map',
        title: 'Curated By Tour Experts',
        content: 'Saving you time researching and planning',
        iconSize: 48,
        contentSize: 'large',
      }],
      [OFFER_TYPE_HOTEL]: [{
        icon: 'handpicked-partner',
        title: 'Best price guarantee',
        content: "If you find a better price, we'll match it",
        iconSize: 48,
        slug: 'best-price-guarantee',
      }, {
        icon: 'refund',
        title: '7-day ‘change of mind’ refund',
        content: 'Get a full refund on your booking (excludes flights, experiences and the service fee paid on deposit bookings)',
        iconSize: 48,
      }, {
        icon: 'vip-inclusions',
        title: 'VIP Inclusions',
        content: 'You get a lot more than just a bed in a room',
        iconSize: 48,
      }, {
        icon: 'buy-now-book-later',
        title: 'Buy now, choose dates later',
        content: "Lock in a deal today, choose dates when you're ready",
        iconSize: 48,
        slug: 'buy-now-book-later',
      }],
      [OFFER_TYPE_LAST_MINUTE]: [{
        icon: 'handpicked-partner',
        title: 'Unbeatable value',
        content: 'Up to 15% (or more) off the best available rate',
        iconSize: 48,
        iconType: 'eighth',
      }, {
        icon: 'vip-inclusions',
        title: 'Exclusive extras',
        content: 'Special inclusions to add a touch of luxury',
        iconSize: 48,
        iconType: 'eighth',
      }, {
        icon: 'hotel',
        title: 'Hand picked hotels',
        content: 'The best hotels and resorts, curated by our team of experts',
        iconSize: 48,
        iconType: 'eighth',
      }, {
        icon: 'calendarIcon',
        title: 'Instant booking',
        content: 'Book with ease and get instant confirmation of your stay',
        iconSize: 48,
        iconType: 'eighth',
      }],
    },
  },
  frontPage: {
    guest: true,
  },
  accommodation: {
    hasBnbl: true,
    allowsMultiRoom: true,
    allowDateChangeOnOrder: true,
  },
  hasMagazine: false,
  hasSubscriptions: true,
  destinationPages: false,
  holidayPages: false,
  topDestinationList: {
    countries: [
      {
        name: 'Australia',
        level: 'country',
      },
      {
        name: 'United States',
        level: 'country',
      },
      {
        name: 'Indonesia',
        level: 'country',
      },
      {
        name: 'Thailand',
        level: 'country',
      },
      {
        name: 'United Kingdom',
        level: 'country',
      },
      {
        name: 'Malaysia',
        level: 'country',
      },
      {
        name: 'New Zealand',
        level: 'country',
      },
      {
        name: 'Fiji',
        level: 'country',
      },
      {
        name: 'Maldives',
        level: 'country',
      },
      {
        name: 'Vietnam',
        level: 'country',
      },
      {
        name: 'Cook Islands',
        level: 'country',
      },
      {
        name: 'Philippines',
        level: 'country',
      },
      {
        name: 'Japan',
        level: 'country',
      },
      {
        name: 'Hong Kong',
        level: 'country',
      },
      {
        name: 'Cambodia',
        level: 'country',
      },
      {
        name: 'Singapore',
        level: 'country',
      },
      {
        name: 'Sri Lanka',
        level: 'country',
      },
      {
        name: 'South Korea',
        level: 'country',
      },
      {
        name: 'Vanuatu',
        level: 'country',
      },
      {
        name: 'India',
        level: 'country',
      },
      {
        name: 'China',
        level: 'country',
      },
      {
        name: 'Samoa',
        level: 'country',
      },
      {
        name: 'Laos',
        level: 'country',
      },
      {
        name: 'Macao',
        level: 'country',
      },
    ],
    cities: [
      {
        name: 'Melbourne',
        level: 'location',
        higherLevel: 'Victoria',
        country: 'Australia',
      },
      {
        name: 'Sydney',
        level: 'location',
        higherLevel: 'New South Wales',
        country: 'Australia',
      },
      {
        name: 'Perth',
        level: 'location',
        higherLevel: 'Western Australia',
        country: 'Australia',
      },
      {
        name: 'Brisbane',
        level: 'location',
        higherLevel: 'Queensland',
        country: 'Australia',
      },
      {
        name: 'Gold Coast',
        level: 'location',
        higherLevel: 'Queensland',
        country: 'Australia',
      },
      {
        name: 'Auckland',
        level: 'location',
        higherLevel: 'Auckland',
        country: 'New Zealand',
      },
      {
        name: 'Port Douglas',
        level: 'location',
        higherLevel: 'Queensland',
        country: 'Australia',
      },
      {
        name: 'Canberra',
        level: 'location',
        higherLevel: 'Australian Capital Territory',
        country: 'Australia',
      },
      {
        name: 'Darwin',
        level: 'location',
        higherLevel: 'Northern Territory',
        country: 'Australia',
      },
      {
        name: 'Hobart',
        level: 'location',
        higherLevel: 'Tasmania',
        country: 'Australia',
      },
      {
        name: 'Launceston',
        level: 'location',
        higherLevel: 'Tasmania',
        country: 'Australia',
      },
      {
        name: 'Port Stephens',
        level: 'location',
        higherLevel: 'New South Wales',
        country: 'Australia',
      },
      {
        name: 'Central Coast',
        level: 'location',
        higherLevel: 'New South Wales',
        country: 'Australia',
      },
      {
        name: 'Cairns',
        level: 'location',
        higherLevel: 'Queensland',
        country: 'Australia',
      },
    ],
    popular: [
      {
        name: 'Melbourne',
        level: 'location',
        higherLevel: 'Victoria',
        country: 'Australia',
      },
      {
        name: 'Sydney',
        level: 'location',
        higherLevel: 'New South Wales',
        country: 'Australia',
      },
      {
        name: 'Perth',
        level: 'location',
        higherLevel: 'Western Australia',
        country: 'Australia',
      },
      {
        name: 'Brisbane',
        level: 'location',
        higherLevel: 'Queensland',
        country: 'Australia',
      },
      {
        name: 'Gold Coast',
        level: 'location',
        higherLevel: 'Queensland',
        country: 'Australia',
      },
      {
        name: 'Bali',
        level: 'location',
        higherLevel: '',
        country: 'Indonesia',
      },
    ],
  },
  topDestinationsPages: [],
  searchFooterBoxType: 'from-config',
  promotionalPages: [],
  bestPriceGuarantee: undefined,
  restrictPhoneNumbersToSupportedRegions: true,
  toursV1Redirects: {
    '0062y00000FmpgbAAB': 'tour-2ba38e1d-b276-4a9a-8898-8d957e2cb9b0',
    '0062y00000IbEcNAAV': 'tour-38fd9af2-7f2c-4b9a-a840-ae64510e4bd2',
    '0062y00000Gx3N5AAJ': 'tour-3abe017f-aaee-413c-b018-b2a491364ffb',
    '0062y00000ECFrqAAH': 'tour-54a26f91-ae43-432e-89f2-da26d72d8f04',
    '0062y00000FLRPxAAP': 'tour-97e062b3-76a9-4a8f-a4ee-523bcb4bebcb',
    '0062y00000EduHRAAZ': 'tour-7e9814dd-0d39-4658-ab5a-6091c70978d3',
    '0062y00000Fiq0sAAB': 'tour-8e5d73d0-7693-446e-b52b-ef0f927373b2',
    '0062y00000FipzcAAB': 'tour-b3c3f9b0-fbf3-4c06-92e1-33ddc610e284',
    '0062y00000DQ692AAD': 'tour-d23b0c20-b933-4ee2-8e61-31f87602f05c',
    '0062y00000GxEwNAAV': 'tour-a8ee1b50-3b3b-473e-b6b0-665d4888b0aa',
    '0062y00000GvKMUAA3': 'tour-110a124e-07cf-4edf-b7d0-14d7867be7eb',
    '0062y00000FLbHdAAL': 'tour-5a8647f5-1588-47e6-aad8-ec59c1fd3415',
    '0062y00000G4d6XAAR': 'tour-7eaad8d6-f274-4a5d-867f-2a65243007aa',
    '0062y00000FMgAgAAL': 'tour-60b53485-35aa-45d1-a7b7-9c8c2934ed17',
    '0062y00000FLFL0AAP': 'tour-b3e21304-757e-49b0-b8fb-e928bd0b1c6d',
    '0062y00000EyJcZAAV': 'tour-3eb2a058-6787-4844-b65e-98ccc6272449',
    '0062y00000EyJdqAAF': 'tour-4ce5842f-b244-4547-8d8b-8a77f57a393a',
    '0062y00000EyIpqAAF': 'tour-66bac9cf-4ed4-4ff5-ab18-4800251d766c',
    '0062y00000GN3MvAAL': 'tour-5fa8506d-eb00-445c-b96a-f540f17aa5ff',
    '0062y00000G4n4EAAR': 'tour-7c233428-cd6e-4a11-8154-2d859e1cf00c',
    '0062y00000FnFUlAAN': 'tour-fee90207-0637-44f9-a023-7cb7b4dc205f',
    '0062y00000FnFL0AAN': 'tour-bb3a642f-8cb8-4a36-af0a-28b3629f618d',
    '0062y00000DI6ibAAD': 'tour-ce900ef1-c248-4546-8919-12e3d1521913',
    '0062y00000EDdDDAA1': 'tour-49c401b4-61c5-4ee1-83a4-d2599893f727',
    '0062y00000Fl1TcAAJ': 'tour-1ef77d5f-2157-4e0d-9cc3-de3bbcda3ed9',
    '0062y00000GfSMoAAN': 'tour-8d3cbf64-3fb2-496d-9565-41bc18716c7e',
    '0062y00000Fn1w0AAB': 'tour-8dff796f-8679-4adb-974f-563b072c66b2',
    '0062y00000EzNhAAAV': 'tour-8a49e66c-7fe3-4d1c-98d1-9816fe5886e2',
    '0062y00000FjFdBAAV': 'tour-b85fc0f6-bb44-49a7-822f-e45c8dd13e0e',
    '0062y00000Fl1KkAAJ': 'tour-db1ea1ac-2567-40d2-a52c-b7a2b658f8d7',
    '0062y00000FLn8sAAD': 'tour-cf0d8f66-0dcc-4af1-98c3-435022f0d9b8',
    '0062y00000FnFYiAAN': 'tour-972dca16-68a2-4bda-b0a1-76dd58d2ad49',
    '0062y00000DqTORAA3': 'tour-9ffa8800-49a1-44cf-9e39-d0256f3d257a',
    '0062y00000Fmp52AAB': 'tour-299ae584-b02e-4aa7-8293-0e86969e9a35',
    '0062y00000C2l22AAB': 'tour-763b661e-4158-43dd-9b74-a5e70c7d54ab',
    '0062y00000GumEmAAJ': 'tour-25f30044-eadc-4204-8c35-dc4ce4e93d91',
    '0062y00000FMhHEAA1': 'tour-2f66acf9-3434-44d6-b350-4c8f9690ea73',
    '0062y00000FMYleAAH': 'tour-809fcce0-1782-46be-8fc6-4149ecbe6bfd',
    '0062y00000FLPhkAAH': 'tour-571b0ea7-a477-4bad-8cba-f033c90ab3a4',
    '0062y00000GvKG2AAN': 'tour-3c2d5f59-4b7f-4599-83e8-0e92e6073b62',
    '0062y00000C5duTAAR': 'tour-17fda6f5-e501-44d2-9a97-62602f6d873f',
    '0062y00000C5iKHAAZ': 'tour-807c6036-5e81-48ca-b852-407efbf11854',
    '0062y00000DNMwnAAH': 'tour-a051b53b-30be-4f52-91c6-cab48d02afb7',
    '0062y00000DPvcOAAT': 'tour-afcf9ec4-da47-4850-864e-e98f47ce7822',
    '0062y00000IafeeAAB': 'tour-404a4f7b-fc9d-4d62-9143-4ce10b80df12',
    '0062y00000EDlZeAAL': 'tour-2449347a-b75e-441c-ac38-caf8567da60c',
    '0062y00000BdTgMAAV': 'tour-4297447c-90ee-444b-9188-984ff96467d4',
    '0062y00000FjCmDAAV': 'tour-acd231d0-79c0-4a4b-823c-57903e9eed7b',
    '0062y00000Fipy8AAB': 'tour-aec03a24-1e8b-4bbe-bec0-14f654bedcc5',
    '0062y00000GfVwxAAF': 'tour-2e2cd002-9f5b-4bdf-8698-86af3e5c3246',
    '0062y00000DN5WSAA1': 'tour-65bea122-8b35-4d95-98f4-caa3f44e39ac',
    '0062y000007oaOUAAY': 'tour-d4ecc336-cd2e-49dc-b824-04e708b31903',
    '0062y00000FoBCsAAN': 'tour-eb94099a-8260-457c-ad70-9c9c000806a8',
    '0062y00000Fiq5sAAB': 'tour-92f84b0e-7df6-45f8-9d34-c4020abbec86',
    '0062y00000GxWW6AAN': 'tour-964a1ec7-26d3-4da6-b673-4c103772fc14',
    '0062y00000DHeOHAA1': 'tour-632ebe08-e789-4310-b67f-1317f45f443a',
    '0062y00000FcJWSAA3': 'tour-e1db1acc-c7df-4b09-aa4d-51c0e6f0e980',
    '0062y00000FLPeCAAX': 'tour-34363b28-bc2c-4231-8259-fc77b7bd4ba0',
    '0062y00000GvTHOAA3': 'tour-154b37ae-a90f-4328-8765-25148d13a7e5',
    '0062y00000DfAIiAAN': 'tour-5d2599a2-c074-49df-9e84-3b5ac105a471',
    '0062y00000GvTRrAAN': 'tour-ff432ffc-8520-4700-9f20-e936db374aa2',
    '0062y00000EduJIAAZ': 'tour-6bc0c72c-d0c3-4d3d-a4e8-20094082f0a0',
    '0062y00000GvHh6AAF': 'tour-d74d3203-176c-4949-9645-0185f4ddbc3f',
    '0062y00000EcXo5AAF': 'tour-79e24b69-ea66-4bc3-9438-4b2bfc676547',
    '0062y00000DR98wAAD': 'tour-615240df-843b-4d12-8613-b05a8b6e99a2',
    '0062y00000Gv5nhAAB': 'tour-20f1c33a-a59b-4eba-8920-b8043c1379c4',
    '0062y00000Gv0vjAAB': 'tour-73bd11da-3200-44cc-b46c-9f9a79f0cbe3',
    '0062y00000EcaZNAAZ': 'tour-7c656f45-ce35-4ba4-87cb-064ca31416a5',
    '0062y00000Dpc9qAAB': 'tour-6eb13d36-556f-47c6-bb12-af2bbec2ebbf',
    '0062y00000DfAK5AAN': 'tour-0ffe88ab-582d-4782-849a-5202ed91ba4a',
    '0062y00000EbjmXAAR': 'tour-0ba0cd7f-b2ac-4478-af75-29881e57541d',
    '0062y00000GMrbcAAD': 'tour-16988d40-d2f9-4289-a4a1-c96c5157c9ca',
    '0062y00000DqD7JAAV': 'tour-613929e1-5df3-4c8d-a044-720cbb8b1cf3',
    '0062y00000FitPgAAJ': 'tour-c9e9a7e1-720c-4f03-8d2f-e2d0ad55e711',
    '0062y00000Gw8PdAAJ': 'tour-5b1b236e-9634-4026-a821-e5b794e1e167',
    '0062y000008nPlbAAE': 'tour-8e29342c-5f96-41a9-ad85-07c2e545bf3c',
    '0062y00000DpbEGAAZ': 'tour-52c88978-9d4a-48af-8149-227b39efcd0a',
    '0062y00000FnD2xAAF': 'tour-e050da55-84e2-4eb0-865f-5680608d6c98',
    '0062y00000FlpOEAAZ': 'tour-48ff130f-b5f7-44e3-8d66-538df0fef35f',
    '0062y00000Fl1MCAAZ': 'tour-d7938292-8e5c-499e-89e1-62ae61157e1b',
    '0062y00000Fl1L9AAJ': 'tour-0b901a8a-ae15-4634-9340-82a015f88495',
    '0062y00000Fl1JwAAJ': 'tour-8dba4330-d81b-49b7-b592-9eacdf38c27f',
    '0062y00000Fl0zHAAR': 'tour-94e76f60-11ad-4844-bf4f-8b34810d0b09',
    '0062y00000Fl1GTAAZ': 'tour-bb86692d-62ac-4770-b25f-c6cf682c7f9a',
    '0062y00000Fl1FfAAJ': 'tour-b13e3b83-54cf-48e6-b3a0-e5dc222e0979',
    '0062y00000FLp23AAD': 'tour-34df3970-3a93-467a-b9b5-c5c21fed6214',
    '0062y00000Ebjk7AAB': 'tour-ded47307-6743-4eb6-94c2-b7e4e579d00c',
    '0062y00000Fn1tGAAR': 'tour-e8d98305-6f47-471d-8efc-9defda9730a6',
    '0062y00000Ias1HAAR': 'tour-8402ba7f-9a36-4301-8be9-bb0a5e6e452c',
    '0062y00000DNMvpAAH': 'tour-3f3927a0-ec12-4c3f-b88a-cb7a60b7d019',
    '0062y00000DQ4uuAAD': 'tour-0df261e0-3748-4f6b-8fd9-d00d122c1137',
    '0062y00000GvIElAAN': 'tour-178304ba-8910-47d9-a4a3-87aed150ee10',
    '0062y00000FmdVRAAZ': 'tour-c41a688e-c621-4229-9d7f-17a3def34ec1',
    '0062y00000DNsrEAAT': 'tour-21527517-3bf4-4cc3-8abb-7e4b586af5cc',
    '0062y00000Ewp4tAAB': 'tour-bbccdadf-d8d4-4d6a-a4dc-32de3bc7f6f3',
    '0062y000006zjsoAAA': 'tour-d984e923-c5c0-4fd5-a2ab-33e1b8f87fc1',
    '0062y000009CK2WAAW': 'tour-cc0c4862-57da-4dcf-a7b3-7233f71efa7e',
    '0062y00000GvDhdAAF': 'tour-f473b131-0724-44a3-b00d-33ef33242481',
    '0062y00000DojWCAAZ': 'tour-0088557d-1b9d-443c-8f29-b0705f69839b',
    '0062y00000GubVmAAJ': 'tour-3ca2d4af-b72a-4003-acaa-63b5a95534be',
    '0062y00000GvU0NAAV': 'tour-5c3b6c1f-c19e-40cc-a103-964b5c95c5a2',
    '0062y00000DfAGOAA3': 'tour-89f65f1f-f429-4b9f-af77-7cc6c2358c28',
    '0062y00000DpcCfAAJ': 'tour-7d054616-a032-4835-80e5-f221943a7b11',
    '0062y00000G26RHAAZ': 'tour-9c24bf7f-7d89-47c2-900d-a0276ea35e04',
    '0062y00000IbkzgAAB': 'tour-16b52481-03c3-4a92-80f4-5250f9377b60',
    '0062y00000FLGJMAA5': 'tour-97984baf-ce06-45a6-a6a1-c283aeadc0fa',
    '0062y00000DNOWeAAP': 'tour-175983bf-7352-4f8d-a566-4625852b88f1',
    '0062y00000Gfhy6AAB': 'tour-03336fa4-5a87-4503-9385-80ebc990e0f2',
    '0062y00000CQkPUAA1': 'tour-544807c0-5012-4680-8dfb-09449664b664',
    '0062y000002Lo3pAAC': 'tour-afe59f76-62ba-439a-b921-15448301fd65',
    '0062y00000FlOuOAAV': 'tour-82d0fec8-1161-4475-b811-6ed2f8220ef3',
    '0062y00000FN8HaAAL': 'tour-04ede99a-7368-491c-8e36-1d88f54490f0',
    '0062y00000FNJ3FAAX': 'tour-f612c615-423e-421c-b64a-d18c2bed5aac',
    '0062y00000FdLdfAAF': 'tour-dcf6d9e1-5848-4be6-b77f-753ce7c1b1d8',
    '0062y00000FcYZGAA3': 'tour-1d56d523-3859-49bd-95ab-52425b4b1295',
    '0062y00000DP0bnAAD': 'tour-fa851690-026c-4edc-96c3-c62af2339285',
    '0062y00000FN6ANAA1': 'tour-8a5c3fe6-2ae1-4cd2-96fd-2ed91dcf5c7b',
    '0062y00000Ec715AAB': 'tour-f613d0b4-ecf4-4b5e-8fff-1aea70739e96',
    '0062y00000DI6qfAAD': 'tour-798e54e7-3293-46ac-a102-20cd9c997f35',
    '0062y00000FnyxvAAB': 'tour-b53d47f0-1e66-4682-8e35-ffe0aaffacc7',
    '0062y00000CNxUBAA1': 'tour-7d48fa15-4a42-476a-91d6-78f588039486',
    '0062y00000GMrevAAD': 'tour-01b05116-fa25-4241-8f17-43b298fb4140',
    '0062y00000GeCc8AAF': 'tour-c436b662-7443-46f9-84d4-d481513002be',
    '0062y00000FlnOlAAJ': 'tour-17aca336-8e15-4006-aec5-7c985689f469',
    '0062y00000Iaru4AAB': 'tour-a10b8799-d0fb-422a-b54d-233d305e50bf',
    '0062y00000Ias8wAAB': 'tour-d5312cbf-7778-456f-8a3d-ae794d28e6d6',
    '0062y00000Iarx5AAB': 'tour-8a21c4c8-1be0-4b2c-a983-8bedae2fe71e',
    '0062y00000FdANWAA3': 'tour-c2387243-54f4-429d-bc33-abf04a1a728d',
    '0062y00000GvHdEAAV': 'tour-cb5da5dc-de92-4c7e-a3ca-559d2b88a469',
    '0062y00000FnG83AAF': 'tour-e59422ad-c6c6-4814-80ec-cc01f359c59a',
    '0062y00000Ex9vDAAR': 'tour-bec7358c-a3c9-46c4-980f-d6e49cfa7ab0',
    '0062y00000G26X5AAJ': 'tour-82a49c46-8de5-4501-9463-c723d104f0cd',
    '0062y00000CQWinAAH': 'tour-0ab15443-c759-4e7d-ad84-c46f5b824b18',
    '0062y00000GdhkdAAB': 'tour-4bd08f0f-bfc5-44ec-9d0e-aad01da72bf9',
    '0062y00000GOvv7AAD': 'tour-8135f1b6-9d58-4ac2-be3d-6bc0cb340925',
    '0062y00000EdTKmAAN': 'tour-ea0a7404-0245-40cc-865c-38805bdd588a',
    '0062y00000GfhF6AAJ': 'tour-26f68a1d-8330-4194-9307-d52f5e6ee57b',
    '0062y00000GOhonAAD': 'tour-a5b35ca3-d583-4ec3-82c2-8ea6fe792562',
    '0062y00000GNeGHAA1': 'tour-f5220b91-9053-47e9-beaf-33116b5d1510',
    '0062y00000FLka5AAD': 'tour-4728e486-4fc0-43de-979b-c6e6ac57962a',
    '0062y00000FLEyBAAX': 'tour-6a1851ef-2fa8-49ed-bd03-6ce34716da96',
    '0062y00000Ez0v1AAB': 'tour-9096ebce-e87a-44d1-a7ae-a07014647579',
    '0062y00000EdbgeAAB': 'tour-8ef90439-95e7-48cb-a1e5-2307f60ea7bf',
    '0062y00000FniovAAB': 'tour-0e570698-751f-4d65-879e-738a485e7645',
    '0062y00000FNJjzAAH': 'tour-cefe7773-f1be-447f-b0a7-b6766b367c3a',
    '0062y00000FN5ExAAL': 'tour-e670fee8-35ea-4178-b9eb-db688758aeb3',
    '0062y00000FN5ACAA1': 'tour-1276255d-2d17-4532-9897-e252c2139257',
    '0062y00000Ewf02AAB': 'tour-6671d5a8-b0b9-4ae0-adc7-b16b5e2d0811',
    '0062y00000DNMytAAH': 'tour-456d06ff-0b4c-4d20-a293-7ad4a1a5be14',
    '0062y00000FmmbiAAB': 'tour-1b8acf73-a3ea-4832-ba76-22145e628045',
    '0062y00000EdbkaAAB': 'tour-fc042e37-eb21-450a-9b28-6876cce6959d',
    '0062y00000DNOqPAAX': 'tour-6f1552f1-4851-4ee5-b92a-5287be57e47a',
    '0062y00000GOdFvAAL': 'tour-953f11c7-350e-4c18-b5a3-47d4ca7b3f5e',
    '0062y00000CNG9gAAH': 'tour-4d0a73c5-bb37-4895-a129-d5fab7fe19fc',
    '0062y00000GuajvAAB': 'tour-6cc82707-ba4e-4728-9045-e925c05ed7be',
    '0062y00000DqKsGAAV': 'tour-c6876018-bc87-49e4-9e6b-dbe099ad2a77',
    '0062y00000DRTToAAP': 'tour-df2f7d97-55ed-42e2-828e-92d44a486685',
    '0062y00000GMrazAAD': 'tour-66de2a53-fafc-4bdd-944d-6809695d950e',
    '0062y00000DqKrmAAF': 'tour-8c8b38f7-554b-445f-b5dd-c84bc0d4e91d',
    '0062y00000DHy59AAD': 'tour-538e0a0f-f49f-42b2-bbb5-de57c50ec3ab',
    '0062y00000GOhleAAD': 'tour-e8f25077-77df-487c-9a08-11439dcf5b94',
    '0062y00000DewfZAAR': 'tour-46b71784-9e33-4dc1-b5f5-d17e02d93338',
    '0062y00000GvavkAAB': 'tour-441dacd2-1573-43d1-9120-6a4dc1f2204d',
    '0062y00000DNMfXAAX': 'tour-dfa765f9-e8c1-49a4-97bf-97620e3aaadd',
    '0062y00000GgvmRAAR': 'tour-0c820a50-152a-4157-a3bd-606c2a9b272b',
    '0062y00000Fo943AAB': 'tour-5bd8e90a-e6be-415c-8bf4-e618a72319d7',
    '0062y00000DojVYAAZ': 'tour-fae5c398-4dff-41f4-b1a7-557347be25e6',
    '0062y00000EwfQ3AAJ': 'tour-21c58611-100e-48ac-aca7-0331298244cc',
    '0062y00000GxkjnAAB': 'tour-247b5694-7cd4-495b-9a50-d2cf8186eb47',
    '0062y00000DfZyxAAF': 'tour-2197a800-37e2-44f3-a955-07a3252ff125',
    '0062y00000GxZL1AAN': 'tour-2b8631de-1969-41aa-b3a9-c55e1c56ae04',
    '0062y00000Fo0TOAAZ': 'tour-872859a5-7649-4121-81aa-0d4319d445b5',
    '0062y000006yAXNAA2': 'tour-12c5030d-42b3-4680-8278-e6089ea253b3',
    '0062y00000EbyryAAB': 'tour-524c3dcd-b071-43af-9b27-a5bfa1081d57',
    '0062y00000DHdynAAD': 'tour-f2137105-b50e-4713-942f-d57af4ae7c3e',
    '0062y00000EdbgdAAB': 'tour-304206fd-ef41-4367-8b9d-9ffea4266b38',
    '0062y00000FLFq3AAH': 'tour-95bedaa2-760d-4e3a-8d89-068ad9bc80dd',
    '0062y00000Ez1yGAAR': 'tour-79202d7f-7c9a-4c41-b378-dc6ac101a55e',
    '0062y00000FcYTIAA3': 'tour-ec5f7b11-6c57-4186-bcca-d37e4fb32e77',
    '0062y00000C5S4HAAV': 'tour-9d8416bf-fb60-4cd8-8664-626921ba09d1',
    '0062y00000EDCSCAA5': 'tour-9b0df7fb-e76b-434a-b94a-a7ce0a744c34',
    '0062y00000DQz3fAAD': 'tour-eb1ece92-0030-4c53-8429-5f854e18d22e',
    '0062y00000IbRyqAAF': 'tour-c9e6da67-59df-4075-95c5-7f82c4a1315a',
    '0062y00000GvK7AAAV': 'tour-4acfc2bf-3d00-4649-95a1-8a55df024518',
    '0062y00000EDggaAAD': 'tour-a0de326b-5ffc-446d-b3bb-db1074aec69f',
    '0062y00000DHxnqAAD': 'tour-ffac5967-835f-4797-9109-fa55ff763b90',
    '0062y00000Dp2HJAAZ': 'tour-d330aa27-bde0-4c03-a383-3da6b56a4e78',
    '0062y00000C5RLRAA3': 'tour-a5faf8c8-dc12-41aa-aa8e-68b5d482f970',
    '0062y00000EyJv7AAF': 'tour-27a82cc9-cf89-42ef-a7ff-a856af85f9f9',
    '0062y00000CQkRQAA1': 'tour-c0b48aaf-aa36-460e-991a-e1249fc761db',
    '0062y00000DI6epAAD': 'tour-dad4368b-0c9e-4ce8-a685-9e74fc2ba89f',
    '0062y00000GwsoZAAR': 'tour-26ca2756-7442-495a-92da-951f3c4855a6',
    '0062y00000DH1oUAAT': 'tour-406e971e-cede-4199-bd76-fc027ed77053',
    '0062y00000FitVoAAJ': 'tour-d7da9b27-0100-4873-9c16-9a6b9e4a97f3',
    '0062y00000EyIabAAF': 'tour-7e7166ff-f9ad-4c85-97e3-423c9758d4bf',
    '0062y00000C2PCZAA3': 'tour-92e5d450-30c3-4ad5-b612-7737871b0c65',
    '0062y00000Gxo0yAAB': 'tour-3fa8c011-aca3-4c87-8570-50bf5e08c64c',
    '0062y00000G4nUQAAZ': 'tour-ceba7ad2-e25e-4f62-8cae-cd36a62a038e',
    '0062y00000CQKqlAAH': 'tour-33426156-4223-4af8-8e78-c7b026d59210',
    '0062y00000Fj5eGAAR': 'tour-a295670b-b01f-4c91-bb2c-2fb6c8de3cc0',
    '0062y00000CO8EZAA1': 'tour-73f6a95b-7001-4799-a60a-89df4c443ef6',
    '0062y00000DQzGUAA1': 'tour-e66e7e58-1520-459f-996c-2203580ef07b',
    '0062y00000CwJdQAAV': 'tour-38d9a722-ee91-46de-b9ee-5f5d0715b3b3',
    '0062y00000ECvN0AAL': 'tour-0827af86-2275-43c6-95a5-6ab00733e8d0',
    '0062y00000EDh4SAAT': 'tour-74b8261c-73b7-4186-b6ff-6a01e785c38f',
    '0062y00000DeswlAAB': 'tour-3ab46266-e41c-47e7-ae36-035afe1603b5',
    '0062y000006yy9dAAA': 'tour-7f3e5fc2-a8e0-44ad-9855-564f23db110f',
    '0062y00000DJ4ToAAL': 'tour-88c0a4e5-226b-4669-9bc5-9a04aa10ff11',
    '0062y00000Gxo5NAAR': 'tour-eb456edb-90f1-42bd-a117-be35b0670f48',
    '0062y00000Fmp5BAAR': 'tour-91cd7c9e-234d-4de9-9f9d-53915492e671',
    '0062y00000Fj5VnAAJ': 'tour-2cfe4895-5ce1-4f99-bae8-09a3e0618ba5',
    '0062y00000FnEEzAAN': 'tour-6c7e3b40-5fac-45e6-8762-709960b0da31',
    '0062y00000C5dtLAAR': 'tour-dce3de1e-5693-42d3-81aa-35fab6b33dbd',
    '0062y00000CvimYAAR': 'tour-0fba075c-fa45-42ef-a63c-f776bd310f55',
    '0062y00000Gxo0xAAB': 'tour-44073e1c-35c9-4046-8eb4-61d09d3a68be',
    '0062y00000DpbFYAAZ': 'tour-2e394fd9-6fb1-404d-b783-6d3427606324',
    '0062y00000FlOxhAAF': 'tour-0a90bed2-cf39-49d7-a753-5b3986df2a13',
    '0062y00000GvM6pAAF': 'tour-a8d16956-7866-410f-8239-911e956df654',
    '0062y00000DpY0kAAF': 'tour-7c38eca2-06c7-4cb0-8562-996795c467a8',
    '0062y00000DR0OjAAL': 'tour-1356d313-34b6-4eee-9abe-e45e4433ff84',
    '0062y00000Ib2FUAAZ': 'tour-28cd0aa1-bb5b-4979-b821-9774c09f6f35',
    '0062y00000FODPbAAP': 'tour-a546b07f-19af-41a3-8d07-e72b9b60bb8f',
    '0062y00000G4oWeAAJ': 'tour-0c81c903-b8bb-4135-a479-4768a6044252',
    '0062y00000C2J1VAAV': 'tour-7be78003-8a72-4a27-96e3-47118c697f40',
    '0062y00000DJ45cAAD': 'tour-24e84b26-3a6d-48c3-9cff-879ff142cde3',
    '0062y00000Fl1HWAAZ': 'tour-dddb1942-90a5-4f0d-80a5-bf4261bbe802',
    '0062y00000Ex0W7AAJ': 'tour-2825a6ec-9cce-4858-8a46-30242bd44e64',
    '0062y00000Ebmg2AAB': 'tour-9388b59f-80e7-4760-9bc6-c26719fef80b',
    '0062y00000EDlZoAAL': 'tour-f6e349f9-672a-4a5c-a5d7-1ae85fe66601',
    '0062y00000EyTnvAAF': 'tour-ff0cad2e-1d45-45b4-9700-fc913046a3aa',
    '0062y00000DH1g1AAD': 'tour-c358a36c-64fc-4b31-9f35-86e45a5b0d29',
    '0062y00000Gw976AAB': 'tour-f24e52d7-1c4f-4dd2-8e14-b7e478cfeebe',
    '0062y00000Gwv74AAB': 'tour-b0e27c9a-081f-4dc1-ba43-d2d659b753ba',
    '0062y00000FnEIhAAN': 'tour-eab7a4b9-7bcf-46c1-838a-ce800fac0dfb',
    '0062y00000FLOwcAAH': 'tour-341c267a-743d-4bb6-ba4d-8fccf9eb4caf',
    '0062y00000GdiiIAAR': 'tour-58434c1b-a059-45b9-a083-50dddd34987d',
    '0062y00000FN6gEAAT': 'tour-9c8cdcbb-a92d-493c-82fa-6e7a16e3fee4',
    '0062y00000EduGUAAZ': 'tour-a64a7c20-d441-4fe4-89dd-c370cf6a0807',
    '0062y00000Gxo6pAAB': 'tour-3bb22f99-cd7a-403e-99bf-115ab4ec57e8',
    '0062y00000Gxz6FAAR': 'tour-2b91861b-49f1-402b-82f1-9c9413f0f84e',
    '0062y00000DIMG6AAP': 'tour-1018f488-9d87-4f06-b457-3cb9fa1f0caf',
    '0062y00000DfA7aAAF': 'tour-a4243694-c527-4bcf-bdee-ff022eaf2950',
    '0062y00000DQ6nlAAD': 'tour-b06cc78b-6cff-44d2-bbc8-79c25d748a23',
    '0062y00000BdTBiAAN': 'tour-5a700484-a93b-44f7-973f-f24ec97d1a7e',
    '0062y00000DJ9jXAAT': 'tour-424e7d46-4950-4a01-8949-12cd480ab0b6',
    '0062y00000DP9YYAA1': 'tour-c8d1be18-3e4f-4607-8230-423c3925c535',
    '0062y00000DH1ezAAD': 'tour-76f1d6e1-395c-4ecc-82ad-05fe00ae04b1',
    '0062y00000FLOq7AAH': 'tour-b3d1c003-ea04-4811-95a0-e593d2ee5e21',
    '0062y00000FLcZiAAL': 'tour-742d5052-3bc1-4f4c-bf0e-596576f3c2dd',
    '0062y00000FMv8wAAD': 'tour-a68d1f53-3390-4e64-890f-65f8efadb9df',
    '0062y00000DpcYRAAZ': 'tour-afe59f76-62ba-439a-b921-15448301fd65',
    '0062y00000DHzAOAA1': 'tour-3af76572-db8b-412c-983f-31d9f55a76e0',
    '0062y00000ED9CuAAL': 'tour-f8a4f098-5ff4-44ce-ad7b-7763f7a170af',
    '0062y00000BffmFAAR': 'tour-b08e3c95-4247-4d95-9202-21bbe3024cee',
    '0062y00000GvTXkAAN': 'tour-32ed0ff6-747a-418a-a08e-f8a4abe995b0',
    '0062y00000DO5dMAAT': 'tour-92a7ba61-513c-474c-8f0d-c890dd87f4b0',
    '0062y00000DQz2mAAD': 'tour-68ed88bd-3e8a-47d8-9386-a1bb4058ed3d',
    '0062y00000CuwYlAAJ': 'tour-cdbf8d67-b0d0-44f1-ae3f-9ba8e8fa40da',
    '0062y00000GumEnAAJ': 'tour-035f4ca8-6143-4351-a6c1-74ff811b545c',
    '0062y000008J55BAAS': 'tour-19568d9e-0e7e-43ae-8194-60cd0d011e15',
    '0062y00000FP82zAAD': 'tour-b951fd9a-9d1b-42fe-850f-a2ad873e9449',
    '0062y00000FcaowAAB': 'tour-54ac2ac5-599e-4a1b-a716-4c812cd67f70',
    '0062y00000CPdMPAA1': 'tour-91916b3a-98b4-4fa2-8882-36b42db2d07a',
    '0062y00000BffNyAAJ': 'tour-035c72ab-a38f-431c-a735-47210bed1a08',
    '0062y00000EbitJAAR': 'tour-c26f3f70-ee4e-430e-88d7-26e7d53f15b7',
    '0062y00000ECvdmAAD': 'tour-28baa2db-ccb2-45ff-85aa-731afe241603',
    '0062y00000DojUaAAJ': 'tour-6b54b28e-246f-4a04-ac3e-3c8f435ba05a',
    '0062y000008npaNAAQ': 'tour-5af07fce-4d95-49a6-8051-2607b2bcb899',
    '0062y00000FlGdeAAF': 'tour-3ec038a5-0b47-4d68-9021-634bdf6e2ea4',
    '0062y00000Fl1HCAAZ': 'tour-3b6bb095-efd7-483d-bc69-4a689dc25614',
    '0062y000009FCEhAAO': 'tour-4ef953f0-dba0-4cad-b249-1d7485b38fef',
    '0062y000008gFEAAA2': 'tour-032cac44-91df-4d76-9260-6594cf1130e2',
    '0062y00000FcYjuAAF': 'tour-400cc282-5c6f-48a5-973c-1ec6f4a0ea1d',
    '0062y00000Df7ghAAB': 'tour-4743a648-be7c-4b75-b33e-50e891ee6e00',
    '0062y00000Df8qTAAR': 'tour-d3cf8366-6885-485e-949c-f78ba6831be3',
    '0062y00000CNG3iAAH': 'tour-fe82a765-9f25-4b8e-8b30-4f17177ac640',
    '0062y00000GvnepAAB': 'tour-d6c115d0-8c91-4111-9a8a-6859520b6fe1',
    '0062y00000DIG73AAH': 'tour-8f2b487f-44f5-4a01-a406-bf59c7322fe2',
    '0062y00000Fl1JXAAZ': 'tour-83b9b546-9bc4-4b62-ba27-d6fa5075a1e4',
    '0062y00000GfhKGAAZ': 'tour-a5881a64-59f5-40ea-b44a-ae5e95429607',
    '0062y00000Gvtw9AAB': 'tour-a79e43ac-82e1-46eb-87b2-72ea02a4c73f',
    '0062y00000G3WHMAA3': 'tour-61cdd0d5-73c7-4fdb-8cc1-250ab392ea56',
    '0062y00000CPB5YAAX': 'tour-3436b325-08f4-4319-a74c-29245dc61dac',
    '0062y00000ECvaYAAT': 'tour-1ca5ef55-e091-40d9-a0a0-7e1b08f3ac17',
    '0062y00000GPdVeAAL': 'tour-e45bec1e-5709-4849-ad7e-8611d7a5b48c',
    '0062y00000Flp2NAAR': 'tour-ce5b8edc-8fa2-425f-ba6c-0311b60f23f7',
    '0062y00000EyIOGAA3': 'tour-21484d6c-e8f9-4514-8f8e-d309b69ac4e6',
    '0062y00000DoBMWAA3': 'tour-fcaf220f-c2d3-4299-a672-58746e265030',
    '0062y00000GuavtAAB': 'tour-4db22cc6-323e-4724-b2cf-d3fab85e4410',
    '0062y00000BfnbCAAR': 'tour-15ce3f79-44b8-4380-bc8b-d22c4c2dbb62',
    '0062y00000GuwpaAAB': 'tour-0c9c3b22-1181-4a57-bb81-ac5f7c10f37a',
    '0062y00000DIND2AAP': 'tour-1b796fe9-064a-488c-be73-404a9074236a',
    '0062y00000EbyaUAAR': 'tour-6b5acae2-e993-4c17-a4ae-1184f27022df',
    '0062y00000Dp2i8AAB': 'tour-9f0ba512-3a68-4dae-bd4e-618ef5451766',
    '0062y00000DHwFrAAL': 'tour-69f078c0-e299-494d-b8a4-3dd4e4f54101',
    '0062y00000FN5CrAAL': 'tour-7b056735-f475-4cf9-a700-b102cffd895b',
    '0062y00000Fj5cKAAR': 'tour-857806b2-c444-44a9-8a2f-567967530a20',
    '0062y00000EwocsAAB': 'tour-e45a549c-1cb2-430b-983c-00cbc92a1231',
    '0062y00000AbP7EAAV': 'tour-8336702f-10f4-4afa-88ce-abdc17ffca02',
    '0062y00000Fl1ENAAZ': 'tour-5c14ddb1-ad88-4dc1-9727-fa992a48922e',
    '0062y00000CO9ZYAA1': 'tour-c299dec6-f3cf-40c1-8832-469679640eef',
    '0062y00000DefrnAAB': 'tour-28879797-c573-47c8-b648-dcdae2e0c484',
    '0062y00000DprThAAJ': 'tour-21b01b9a-10dc-4de2-a78d-5096a5a2bc8b',
    '0062y00000DOpZ9AAL': 'tour-22c22343-123d-4604-8d55-a4fc93f2109a',
  },
  currencyRedirectEnabled: false,
  legalPagesSideBar: false,
  contactForm: false,
  defaultRegion: 'AU',
  search: {
    defaultOccupants: {
      adults: 2,
      children: 0,
      childrenAge: [],
      childrenBirthDate: [],
      infants: 0,
    },
    mapView: {
      pinLimit: 10,
      additionalPins: 10,
    },
  },
  analytics: {
    interactionStudio: false,
  },
  head: {
    metaTitleForDestinationProductPage: '',
    defaultTitle: '',
    defaultDescription: '',
    brandOpenGraphImageId: '',
  },
  displayDiscountThreshold: {
    // These are decimal numbers because they are calculated from the price and the value
    flash: 0.05,
    bedbank: 0.05,
    // Last minute price and value are always the same. This is a whole
    // number because it is a field that comes from the admin portal
    lastMinute: 5,
  },
  bp: {
    mobile: 426,
    phablet: 600,
    smallLogo: 1300,
    bookingCalendar: 820,
  },
  supportUrl: 'https://lehelpterminal.force.com/helpluxeveryday/s/',
}

export default baseConfig
